import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
import { messageService } from 'src/app/message.service';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';
import { catchError, lastValueFrom, of } from 'rxjs';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { SessionTimeoutService } from 'src/app/session-timeout-dialog/session-timeout.service';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-forms-logs-detail',
  templateUrl: './forms-logs-detail.component.html',
  styleUrls: ['./forms-logs-detail.component.scss']
})
export class FormsLogsDetailComponent implements OnInit {

  isProcessing = false;
  formObj: any;
  firstFieldsList: any = [];
  sectionList: any = [];
  templateData: any = {};
  warningMsg: any = "";
  showObsoleteInMenu: boolean = false;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '100%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  visibleInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  infoPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  userTimeZone: any;
  visibleConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;

  visibleConfirmWithData: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithDataPopup', { static: true }) confirmWithDataPopup: TemplateRef<any>;

  confirmPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  confirmWithDataPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  datePickerConfiguration1 = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  dateTimePickerConfiguration = {
    dateInputFormat: this.dateFormat + ' HH:mm:ss',
    showWeekNumbers: false,
    withTimepicker: true,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    autoClose: false,
  }
  dateTimePickerConfiguration1 = {
    dateInputFormat: this.dateFormat + ' HH:mm:ss',
    showWeekNumbers: false,
    withTimepicker: true,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    autoClose: false,
  }
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  visibleSwitchUserPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('switchUserPopup', { static: true }) switchUserPopup: TemplateRef<any>;

  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('searchDocument', { static: true }) searchDocument: TemplateRef<any>;
  visibleSearchDocumentPopup: MatDialogRef<TemplateRef<any>>;

  searchDocumentConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  switchUserPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  @ViewChild('verifyPopup', { static: true }) verifyPopup: TemplateRef<any>;
  visibleVerifyPopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('withdrawPopup', { static: true }) withdrawPopup: TemplateRef<any>;
  visibleWithdrawPopup: MatDialogRef<TemplateRef<any>>;


  verifyPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  formUserData: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  invisibleSectionsList: any = [];
  invisibleSectionFieldsList: any = [];
  noneditableSectionFieldsList: any = [];
  isAdenabled: boolean = false;
  temFormObj: any = {};

  reportOrNormal: boolean = false;
  constructor(public dialog: MatDialog, public appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, private readonly authService: MsalService,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, private readonly sessionTimeoutService: SessionTimeoutService) {
    const data: any = router.getCurrentNavigation()?.extras.state;
    this.formObj = data['formObj'];
    this.formObj.module = "FORMS";
    this.temFormObj = this.formObj;
    this.isProcessing = true;
    this.appService.getFormTemplateByTemplateId(this.formObj.templateId)
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.templateData = data[0];
        this.templateData.listOfStages = this.templateData.listOfStages.split(",").join("/");
      })
    this.appService.getFormUsersByUserId(this.formObj.templateId,
      this.formObj.formId, this.message.getUserId()).subscribe((data: any) => {
        if (data.length > 0) {
          this.formUserData = data[0];
          if (this.formUserData.invisibleFormSections != null) {
            this.invisibleSectionsList = this.formUserData.invisibleFormSections.split(",");
          }
          if (this.formUserData.invisibleFormSectionFields != null) {
            this.invisibleSectionFieldsList = this.formUserData.invisibleFormSectionFields.split(",");
          }
          if (this.formUserData.noneditableFormSectionFields != null) {
            this.noneditableSectionFieldsList = this.formUserData.noneditableFormSectionFields.split(",");
          }
        } else {
          this.formUserData = {};
        }

        this.initMethod();
      })
  }

  @ViewChild('datePicker', { static: false }) datepicker!: BsDatepickerDirective;

  onDateChange(datepicker: BsDatepickerDirective): void {
    setTimeout(() => {
      datepicker.show();
    }, 0);
  }

  getDateFormat(val: any): string {
    let format = this.appService.organizationDetails?.htmlDateFormat || 'dd-MMM-yyyy';
    format = format.replaceAll('Y', 'y').replaceAll('D', 'd');

    if (val === 'Datetime') {
      format += ' HH:mm:ss';
    }

    return format;
  }




  verifierSearchText: string = '';
  withdrawerSearchText: string = '';
  switchUserSearchText: string = '';
  flexifieldValueTxt: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  @ViewChild('flexifieldValueSelected1') flexifieldValueSelected1: MatSelect;
  flexifieldValueSelected = false;
  toggleAllSelection(value: any) {
    if (value == 'flexifieldValueSelected') {
      if (this.flexifieldValueSelected) {
        this.flexifieldValueSelected1.options.forEach((item: MatOption) => item.select());
      } else {
        this.flexifieldValueSelected1.options.forEach((item: MatOption) => item.deselect());
      }
    }

  }

  get canModifyDocument(): boolean {
    const hasEditRights = this.saveButtonForForm;
    const isSelfLocked = this.formObj?.status === 'Locked';
    return hasEditRights || isSelfLocked;
  }
  displayUserName: any;
  uiDateFormat: any = 'dd-MMM-yyyy';
  uiDateTimeFormat: any = 'dd-MMM-yyyy HH:mm:ss';

  get safeDateFormat(): string {
    const fmt = this.uiDateTimeFormat || 'dd-MMM-yyyy HH:mm:ss';
    return fmt.replaceAll('Y', 'y').replaceAll('D', 'd');
  }
  ngOnInit(): void {
    this.userTimeZone = localStorage.getItem("timezone");
    if (this.userTimeZone == "null") {
      this.userTimeZone = "GMT"
    }
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');

    if (obj.uiDateFormat != undefined && obj.uiDateFormat != null) {
      // Potential Issue 2: Only replacing 'DD' and 'MON', but leaving 'YYYY' untouched if present
      this.uiDateFormat = obj.uiDateFormat.replace("DD", 'dd').replace("MON", "MMM");
    }

    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat.replace("DD", 'dd').replace("HH24:MI:SS", 'HH:mm:ss').replace("MON", "MMM");
    }
    this.displayUserName = userData.userNameAtApplication;
    this.message.isShowApplicableForAllCheckBox = false;
    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("FRM", 0).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    const now = new Date();
    this.isProcessing = true;
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    if (this.formObj.isFrom == "TEMPLATE") {
      this.saveButtonForForm = true;
    } else {
      this.getButtonLabels();
    }

  }

  stageName: any;
  actionStatusOptions: any;
  instructions: any;
  buttonLabels: any = [];
  saveButtonForForm = false;
  selectedTabIndex = 0;
  isShowStageTab = false;
  getButtonLabels() {
    this.saveButtonForForm = false;
    this.showObsoleteInMenu = false;
    this.isProcessing = true;
    let obj = {

      formId: this.formObj['formId'],
      status: this.formObj['status']
    }
    this.appService.getFormButtonLabels(obj).subscribe((data: any) => {
      this.isShowStageTab = true;
      this.isProcessing = false;
      this.stageName = data.stageName;
      this.actionStatusOptions = data.actionStatusOptions;
      this.instructions = data.instructions;
      if (data.buttonLabels != null) {
        this.buttonLabels = data.buttonLabels.split(",");
        for (let i = 0; i < this.buttonLabels.length; i++) {
          if (this.buttonLabels[i] == "Save") {
            this.saveButtonForForm = true;
            this.formObj['saveButtonForForm'] = true;
            this.buttonLabels = this.buttonLabels.filter((obj: string) => { return obj !== "Save" });
            i--;
          }
          if (this.buttonLabels[i] == "Cancel") {
            this.buttonLabels = this.buttonLabels.filter((obj: string) => { return obj !== "Cancel" });
            i--;
          }
          if (this.buttonLabels[i] == "Obsolete") {
            this.showObsoleteInMenu = true;
            this.buttonLabels = this.buttonLabels.filter((obj: string) => { return obj !== "Obsolete" });
            i--;
          }
        }

      }
    })
  }

  firstFormObj: any = {};
  initMethod() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getActiveFormFields(this.formObj.templateId, 0)
      .subscribe((data: any) => {
        this.firstFieldsList = [];
        if (this.invisibleSectionFieldsList.length > 0) {
          for (const item of data) {
            const match = this.invisibleSectionFieldsList?.find((val: any) => val == item.fieldId);
            if (!match) {
              this.firstFieldsList.push(item);
            }
          }
        } else {
          this.firstFieldsList = data;
        }

        this.isProcessing = false;
        for (let i = 0; i < this.firstFieldsList.length; i++) {

          this.firstFieldsList[i].isNotEditable = false;
          for (const noneditableField of this.noneditableSectionFieldsList) {
            if (data[i].fieldId == Number(noneditableField)) {
              this.firstFieldsList[i].isNotEditable = true;
            }
          }
          if (this.firstFieldsList[i].isEditable == "N") {
            this.firstFieldsList[i].isNotEditable = true;
          }
          this.firstFieldsList[i].dropDownValues = [];
          this.firstFieldsList[i].dropdowns = [];
          this.firstFieldsList[i].checkedCheckBoxValue = [];
          this.firstFieldsList[i].selectedFlexifieldValue = [];
          this.firstFieldsList[i].maxDate = null;
          this.firstFieldsList[i].minDate = null;
          if (this.firstFieldsList[i].fieldDatatype == "Date" || this.firstFieldsList[i].fieldDatatype == "Datetime") {
            this.dateValidation(this.firstFieldsList[i]);
          }
          if (this.firstFieldsList[i].fieldType == "Drop Down" || this.firstFieldsList[i].fieldType == "Horizontal Checkbox Button" ||
            this.firstFieldsList[i].fieldType == "Vertical Checkbox Button" || this.firstFieldsList[i].fieldType == "Horizontal Radio Button" ||
            this.firstFieldsList[i].fieldType == "Vertical Radio Button" || this.firstFieldsList[i].fieldType == "Multiselect Drop Down") {
            if (this.firstFieldsList[i].fieldLovValues != null) {
              if (this.firstFieldsList[i].fieldDatatype == "Number") {
                this.firstFieldsList[i].dropDownValues = this.firstFieldsList[i].fieldLovValues.split(",").map(Number);
              } else {
                this.firstFieldsList[i].dropDownValues = this.firstFieldsList[i].fieldLovValues.split(",");
              }

              for (const dropDownValue of this.firstFieldsList[i].dropDownValues) {
                this.firstFieldsList[i].dropdowns = this.firstFieldsList[i].dropdowns.concat({
                  valueExp: dropDownValue,
                  displayExp: dropDownValue
                });
              }

              if (this.firstFieldsList[i].fieldDefaultValue != null) {
                for (const dropdown of this.firstFieldsList[i].dropdowns) {
                  if (this.firstFieldsList[i].fieldDefaultValue == dropdown.valueExp) {
                    this.firstFieldsList[i].selectedFlexifieldValue = [{
                      valueExp: dropdown.valueExp,
                      displayExp: dropdown.displayExp
                    }];
                  }
                }
              }

            } else if (this.firstFieldsList[i].fieldLovQuery != null) {
              this.buildDropdownFromQuery(this.firstFieldsList[i]);
            }
            if (this.firstFieldsList[i].fieldType == "Vertical Checkbox Button" || this.firstFieldsList[i].fieldType == "Horizontal Checkbox Button") {
              if (this.firstFieldsList[i].fieldDefaultValue != null) {
                if (this.firstFieldsList[i].fieldDatatype == "Number") {
                  if (Number.isNaN(this.firstFieldsList[i].fieldDefaultValue)) {
                    this.firstFieldsList[i].checkedCheckBoxValue = this.firstFieldsList[i].fieldDefaultValue.split(",");
                  } else {
                    this.firstFieldsList[i].checkedCheckBoxValue.push(this.firstFieldsList[i].fieldDefaultValue);
                  }

                } else {
                  this.firstFieldsList[i].checkedCheckBoxValue = this.firstFieldsList[i].fieldDefaultValue.split(",");
                }
              }
            } else if (this.firstFieldsList[i].fieldType == "Multiselect Drop Down") {
              if (this.firstFieldsList[i].fieldDefaultValue != null) {
                this.firstFieldsList[i].selectedFlexifieldValue = this.firstFieldsList[i].fieldDefaultValue.split(",");
              }
            }
          }
        }

        this.appService.getFormSectionData(this.formObj['formId'],
          0).subscribe((data: any) => {
            if (data.length > 0) {
              this.firstFormObj = data[0];
              for (const field of this.firstFieldsList) {
                if (field.mappingColumn != null) {
                  let finalvariable = this.makeVariable(field);
                  if (data[0][finalvariable] != null) {

                    if (field.fieldDatatype == "Date" || field.fieldDatatype == "Datetime") {
                      if (data[0][finalvariable]) {
                        const userTimezone = localStorage.getItem('timezone') || 'Asia/Kolkata';
                        const apiDate = data[0][finalvariable];
                        field.fieldDefaultValue = utcToZonedTime(apiDate, userTimezone);

                      } else {
                        if (field.fieldLovValues != null && field.fieldLovValues == "Current Date") {
                          console.log("data[0][finalvariable]=======" + data[0][finalvariable]);
                          field.fieldDefaultValue = data[0][finalvariable];
                        } else {
                          field.fieldDefaultValue = null;
                        }
                      }

                    } else {
                      field.fieldDefaultValue = data[0][finalvariable];
                    }


                    if (field.fieldType == "Drop Down") {
                      field.selectedFlexifieldValue = [{
                        valueExp: data[0][finalvariable],
                        displayExp: data[0][finalvariable]
                      }]
                    }

                    if (field.fieldType == "Vertical Checkbox Button" || field.fieldType == "Horizontal Checkbox Button") {
                      if (field.fieldDefaultValue != null) {
                        if (field.fieldDatatype == "Number") {
                          if (Number.isNaN(field.fieldDefaultValue)) {
                            field.checkedCheckBoxValue = field.fieldDefaultValue.split(",");
                          } else {
                            field.checkedCheckBoxValue.push(field.fieldDefaultValue);
                          }

                        } else {
                          field.checkedCheckBoxValue = field.fieldDefaultValue.split(",");
                        }
                      }
                    } else if (field.fieldType == "Multiselect Drop Down") {
                      if (field.fieldDefaultValue != null) {
                        field.selectedFlexifieldValue = field.fieldDefaultValue.split(",");
                      }
                    }

                  }
                }
              }
            }
          })
      })

    this.appService.getSectionListByTemplateId(this.formObj.templateId, this.formObj.formId)
      .subscribe((data: any) => {
        this.sectionList = [];
        if (this.invisibleSectionsList.length > 0) {
          for (const item of data) {
            const match = this.invisibleSectionsList?.find((val: any) => val == item.sectionId);
            if (!match) {
              this.sectionList.push(item);
            }
          }
        } else {
          this.sectionList = data;
        }

        this.isProcessing = false;
        this.IsViewTabs = true;
        for (const section of this.sectionList) {
          section.fieldsPerLine ??= 4;
          this.callSectionData(section);
          section.columnList = [];
          section.columnList = [{ "fieldName": 'Seq', "width": "80" }];

          for (const field of section.fieldsList) {
            section.columnList.push(field);
          }

          for (const field of section.fieldsList) {
            field.isNotEditable = false;

            for (const noneditableField of this.noneditableSectionFieldsList) {
              if (field.fieldId == Number(noneditableField)) {
                field.isNotEditable = true;
              }
            }

            if (field.isEditable == "N") {
              field.isNotEditable = true;
            }

            field.dropDownValues = [];
            field.dropdowns = [];
            field.checkedCheckBoxValue = [];
            field.selectedFlexifieldValue = [];

            if (field.fieldDatatype == "Date" || field.fieldDatatype == "Datetime") {
              this.dateValidation(field);
            }

            if (field.fieldType == "Drop Down" || field.fieldType == "Horizontal Checkbox Button" ||
              field.fieldType == "Vertical Checkbox Button" || field.fieldType == "Horizontal Radio Button" ||
              field.fieldType == "Vertical Radio Button" || field.fieldType == "Multiselect Drop Down") {

              if (field.fieldLovValues != null) {
                if (field.fieldDatatype == "Number") {
                  field.dropDownValues = field.fieldLovValues.split(",").map(Number);
                } else {
                  field.dropDownValues = field.fieldLovValues.split(",");
                }

                for (const dropDownValue of field.dropDownValues) {
                  field.dropdowns = field.dropdowns.concat({
                    valueExp: dropDownValue,
                    displayExp: dropDownValue
                  });
                }

                if (field.fieldDefaultValue != null) {
                  for (const dropdown of field.dropdowns) {
                    if (field.fieldDefaultValue == dropdown.valueExp) {
                      field.selectedFlexifieldValue = [{
                        valueExp: dropdown.valueExp,
                        displayExp: dropdown.displayExp
                      }]
                    }
                  }
                }

              } else if (field.fieldLovQuery != null) {
                this.buildDropdownFromQuery(field);
              }

              if (field.fieldType == "Vertical Checkbox Button" || field.fieldType == "Horizontal Checkbox Button") {
                if (field.fieldDefaultValue != null) {
                  if (field.fieldDatatype == "Number") {
                    if (Number.isNaN(field.fieldDefaultValue)) {
                      field.checkedCheckBoxValue = field.fieldDefaultValue.split(",");
                    } else {
                      field.checkedCheckBoxValue.push(field.fieldDefaultValue);
                    }

                  } else {
                    field.checkedCheckBoxValue = field.fieldDefaultValue.split(",");
                  }
                }
              } else if (field.fieldType == "Multiselect Drop Down") {
                if (field.fieldDefaultValue != null) {
                  field.selectedFlexifieldValue = field.fieldDefaultValue.split(",");
                }
              }
            }
          }
        }
      })
  }
  dateValidation(field: any) {
    if (field.fieldLovValues) {
      if (field.fieldLovValues == "Current Date") {
        console.log("======**Current Date***=====")

        if (field.fieldDefaultValue) {
          field.fieldDefaultValue = new Date();
          field.maxDate = new Date();
          field.minDate = new Date();
        } else {
          field.maxDate = new Date();
          field.minDate = field.fieldDefaultValue;
        }
      } else if (field.fieldLovValues == "Future Date") {
        field.maxDate = null;
        field.minDate = new Date();
        field.minDate.setDate(field.minDate.getDate() + 1);
      } else if (field.fieldLovValues == "Past Date") {
        field.maxDate = new Date();
        field.maxDate.setDate(field.maxDate.getDate() - 1);
        field.minDate = null;
      } else if (field.fieldLovValues.includes("+")) {
        field.maxDate = new Date();
        let date = Number.parseInt(field.fieldLovValues.split("+")[1]);
        field.maxDate.setDate(field.maxDate.getDate() + date);
        field.minDate = new Date();
      } else if (field.fieldLovValues.includes("-")) {
        field.minDate = new Date();
        let date = Number.parseInt(field.fieldLovValues.split("-")[1]);
        field.minDate.setDate(field.minDate.getDate() - date);
        field.maxDate = new Date();
      }
    } else {
      field.maxDate = null;
      field.minDate = null;
    }
  }



  buildDropdownFromQuery(data: any) {
    this.isProcessing = true;
    let obj = {

      searchQuery: data.fieldLovQuery
    }
    this.appService.getLovQueryResult(obj).subscribe((response: any) => {
      this.isProcessing = false;
      data.dropDownValues = response;
      for (const dropDownValue of data.dropDownValues) {
        data.dropdowns = data.dropdowns.concat({
          valueExp: dropDownValue.key,
          displayExp: dropDownValue.value
        });
      }

      if (data.fieldDefaultValue != null) {
        for (const dropdown of data.dropdowns) {
          if (data.fieldDefaultValue == dropdown.valueExp) {
            data.selectedFlexifieldValue = [{
              valueExp: dropdown.valueExp,
              displayExp: dropdown.displayExp
            }];
          }
        }
      }
    })
  }

  refreshGrid(section: any) {
    this.callSectionData(section);
  }

  callSectionData(sectionData: any) {
    let userId = this.message.getUserId();
    this.isProcessing = true;
    this.appService.getFormSectionData(this.formObj['formId'],
      sectionData.sectionId).subscribe((data: any) => {
        this.isProcessing = false;
        sectionData.rowList = data;
        sectionData.dataList = [];
        for (const row of sectionData.rowList) {
          row.isShowVerifyButton = false;
          row.isShowWithdrawButton = false;

          if (row.verificationRequestedOn != null) {
            row.verificationRequestedOn = new Date(row.verificationRequestedOn);
          }
          if (row.verifiedOn != null) {
            row.verifiedOn = new Date(row.verifiedOn);
          }
          if ((row.status == "Draft" || row.status == "Verification Rejected"
            || row.status == "Verifier Requested More Info.")) {
            row.isShowVerifyButton = true;
            row.titleForSectionVerifyButton = "Submit for Verification";
          } else if (row.status == "Pending Verification" && row.verifiedBy == userId) {
            row.isShowVerifyButton = true;
            row.titleForSectionVerifyButton = "Verify";
          }

          if ((row.status == "Verified" || row.status == "Withdrawal Rejected"
            || row.status == "Withdrawer Requested More Info.")) {
            row.isShowWithdrawButton = true;
            row.titleForSectionWithdrawButton = "Submit for Withdrawal";
          } else if (row.status == "Pending Withdrawal" && row.withdrawnBy == userId) {
            row.isShowWithdrawButton = true;
            row.titleForSectionWithdrawButton = "Withdraw";
          }

          let data: any = [];
          data.push(row.recordSeq);

          for (const field of sectionData.fieldsList) {
            let key = this.getColumnName(field.mappingColumn);

            if (field.fieldDatatype == "Date" || field.fieldDatatype == "Datetime") {
              if (row[key]) {

                let formattedDate;

                if (field.fieldDatatype == "Datetime") {
                  formattedDate = this.convertDateAndTime(new Date(row[key]));
                } else {
                  formattedDate = this.convertDate(new Date(row[key]));
                }

                data.push(formattedDate);
              } else {
                data.push(null);
              }

            } else {
              data.push(row[key]);
            }

          }
          sectionData.dataList.push(data);
        }
      })
  }

  convertDate(date: any) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate();

    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];

    const year = date.getFullYear();

    return `${day}-${monthName}-${year}`
  }

  convertDateAndTime(date: any) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate();

    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];

    const year = date.getFullYear();
    return `${day}-${monthName}-${year} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
  }

  checkBoxChecked(data: any, event: any, val: any) {
    if (event.checked) {
      data.checkedCheckBoxValue.push(val);
    } else {
      let index = data.checkedCheckBoxValue.indexOf(val);
      data.checkedCheckBoxValue.splice(index, 1);
    }
  }

  makeVariable(data: any) {
    let splittedData = data.mappingColumn.toLowerCase().split("_");
    for (let j = 1; j < splittedData.length; j++) {
      splittedData[j] = splittedData[j].charAt(0).toUpperCase() + splittedData[j].slice(1);
    }
    let finalvariable = splittedData.join('');
    return finalvariable;
  }

  isMandatoryField = false;
  saveFormFunc() {
    this.isProcessing = true;
    let obj: any = {

      formId: this.formObj['formId'],
      sectionId: 0
    }
    this.isMandatoryField = false;
    for (const field of this.firstFieldsList) {
      if (field.fieldType == "Horizontal Checkbox Button" || field.fieldType == "Vertical Checkbox Button") {
        field.fieldDefaultValue = null;
        for (const checkedValue of field.checkedCheckBoxValue) {
          if (field.fieldDefaultValue == null) {
            field.fieldDefaultValue = checkedValue;
          } else {
            field.fieldDefaultValue = field.fieldDefaultValue + "," + checkedValue;
          }
        }

      } else if (field.fieldType == "Multiselect Drop Down") {
  field.fieldDefaultValue = (field.selectedFlexifieldValue && field.selectedFlexifieldValue.length > 0) 
    ? field.selectedFlexifieldValue.join(",") 
    : null;
}

      if (field.mappingColumn) {
        let finalVariable = this.makeVariable(field);
        if (finalVariable.includes("date")) {
          if (field.fieldDefaultValue != null) {

            const userTimezone = localStorage.getItem('timezone') || 'Asia/Kolkata';
            const browserSelectedStartDate: Date = field.fieldDefaultValue;
            const utcStartDate = zonedTimeToUtc(browserSelectedStartDate, userTimezone);
            obj[finalVariable] = utcStartDate.toISOString();

          }
        }

        else if (field.fieldDatatype == "NUMBER") {
          obj[finalVariable] = Number.parseInt(field.fieldDefaultValue);
        } else {
          obj[finalVariable] = field.fieldDefaultValue;
        }
      }
      if ((field.fieldDefaultValue == null || field.fieldDefaultValue == "") && field.isMandatory == 'Y' && field.fieldType != "Auto Generated Number" && !field.isNotEditable) {
        this.isMandatoryField = true;
      }
    }
    if (this.isMandatoryField) {
      this.isProcessing = false;
      this.warningMsg = "Please enter all mandatory fields!";
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
    } else {
      if (this.firstFormObj.recordId != null && this.firstFormObj.recordId != undefined) {
        obj.recordId = this.firstFormObj['recordId'];
        obj.recordSeq = this.firstFormObj['recordSeq'];
        console.log("obj=", obj);
        this.appService.updateSectionData(obj).subscribe((data: any) => {
          if (this.formObj.isFrom == "TEMPLATE") {
            this.saveButtonForForm = true;
          } else {
            this.getButtonLabels();
          }
          if (data.resultType == "S") {
            this.isProcessing = false;
            this.initMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });



          this.isProcessing = false;
        })
      } else {
        this.appService.addSectionData(obj).subscribe((data: any) => {
          if (this.formObj.isFrom == "TEMPLATE") {
            this.saveButtonForForm = true;
          } else {
            this.getButtonLabels();
          }
          let displayMessage = data.result;
          if (data.resultType == 'E' && data.result.includes('The user do not have handle form/verify/withdraw data privileges')) {
            displayMessage = "Action not allowed: This is a preview popup and does not support data entry.";
          }
          if (data.resultType == "S") {
            this.isProcessing = false;
            this.initMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: displayMessage,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });



          this.isProcessing = false;
        })
      }
    }
  }

  back() {
    history.back();
  }

  buttonLabel: any;
  reason: any;
  title: any;
  statusDropdown: any = [];
  selectedStatus: any = [];
  userName: any;
  statusList: any = [];
  isAllSectionsVerified: boolean;
  switchedToUser: any;
  dropdownForSwitchUsers: any = [];

  areHeaderFieldsValid(): boolean {
    if (!this.firstFieldsList) return true;

    for (const field of this.firstFieldsList) {
      // Skip auto-generated fields completely
      if (field.fieldType === "Auto Generated Number") continue;

      // Skip non-editable fields
      if (field.isNotEditable === "Y") continue;

      // Skip non-mandatory fields
      if (field.isMandatory !== "Y") continue;

      const value = field.fieldDefaultValue;

      // Handle special cases
      if (field.fieldType === "Multiselect Drop Down" && field.isMandatory === "Y") {
        const selectedValues = field.selectedFlexifieldValue;
        if (!selectedValues || selectedValues.length === 0) {
          this.warningMsg = `Please fill mandatory field`;
          this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
          return false;
        }
      } else if ((field.fieldType === 'Horizontal Checkbox Button' ||
        field.fieldType === 'Vertical Checkbox Button') && field.isMandatory === "Y") {
        const checkedValues = field.checkedCheckBoxValue;
        if (!checkedValues || checkedValues.length === 0) {
          this.warningMsg = `Please fill mandatory field`;
          this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
          return false;
        }
      } else {
        // Regular field validation
        if (!value || value.toString().trim() === '') {
          this.warningMsg = `Please fill mandatory field}`;
          this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
          return false;
        }
      }
    }
    return true;
  }
  dynamicButtonClick(button: string) {
    this.buttonLabel = button;
    if (button.includes("Submit")) {
      // First: Validate header fields (in-memory)
      if (!this.areHeaderFieldsValid()) return;

      // Then: Validate section fields (from saved data)
      this.validateMandatorySectionFields().then(isValid => {
        if (!isValid) return;

        // Then check section verification if needed
        this.isAllSectionsVerified = true;
        for (const section of this.sectionList) {
          if (section.verificationReqd === "Y") {
            for (const row of section.rowList) {
              if (row.status !== "Verified") {
                if (section.withdrawalReqd === "Y" && row.status == "Pending Withdrawal") {
                  this.isAllSectionsVerified = false;
                  this.warningMsg = "Please complete Pending Withdrawal record(s) to proceed " + button;
                  break;
                } else if (
                  (section.withdrawalReqd === "N" && row.status !== "Verified") ||
                  (section.withdrawalReqd === "Y" && row.status !== "Verified" && row.status !== "Withdrawn" && row.status !== "Withdrawal Rejected" && row.status !== "Withdrawer Requested More Info.")
                ) {
                  this.isAllSectionsVerified = false;
                  this.warningMsg = "Please verify all required sections before " + button;
                  break;
                }
              }
            }
            if (!this.isAllSectionsVerified) break;
          }
        }

        if (this.isAllSectionsVerified) {
          this.reportOrNormal = false;
          this.appService.getFormSectionData(this.formObj['formId'],
            0).subscribe((data: any) => {
              console.log("55");
              if (data.length == 0 && this.saveButtonForForm && this.firstFieldsList.length > 0) {
                console.log("5445");
                this.visibleExcelPdfPopupWarning = this.dialog.open(this.excelPdfPopupWarning, this.excelPdfPopupConfig);
              } else {
                console.log("54333345");
                this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
              }
            });
        } else {

          this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
        }
      });

      return;
    }
    if (button == "Obsolete" || button == "Inactivate" || button == "Delete" || button == "Activate" || button == "Update"
      || button == "Self Lock" || button == "Create New Version") {
      this.title = button;
      this.reason = null;
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    } else if (button == "Switch User") {
      this.switchedToUser = null;
      this.comments = null;
      this.isProcessing = true;

      this.appService.getUsersListForSwitch(
        this.formObj.formId).subscribe((data: any) => {
          this.isProcessing = false;
          this.dropdownForSwitchUsers = data;
        })
      this.visibleSwitchUserPopup = this.dialog.open(this.switchUserPopup, this.switchUserPopupConfig);
    } else if (button == "Review" || button == "Approve") {
      this.password = "";
      this.comments = "";
      this.statusDropdown = [];
      this.userName = localStorage.getItem("loggedUserName");
      this.selectedStatus = [];
      this.selectedStatusValue = "";
      this.statusList = [];
      let data1: any = [];
      this.evidenceFile = null;
      this.fileExtn = null;
      if (this.actionStatusOptions != null) {
        data1 = this.actionStatusOptions.split(",");
      }
      for (const item of data1) {
        let data2 = item.split("/");
        if (data2.length > 1) {
          this.statusList.push({ codelistCode: data2[1].trim(), codelistName: data2[0].trim() });
        } else {
          this.statusList.push({ codelistCode: data2[0].trim(), codelistName: data2[0].trim() });
        }
      }

      for (const statusItem of this.statusList) {
        this.statusDropdown = this.statusDropdown.concat({
          valueExp: statusItem.codelistCode,
          displayExp: statusItem.codelistName
        });
      }
      this.isProcessing = true;
      this.appService.getModuleStages("FORM", this.buttonLabel)
        .subscribe((data: any) => {
          this.isProcessing = false;
          if (data.length > 0) {
            if (data[0].esignReqd == "Y") {
              this.isEsignRequired = true;
            }
          }
        })
      this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
    } else {
      this.title = button;
      if (button.includes("Submit")) {
        this.isAllSectionsVerified = true;
        for (const section of this.sectionList) {
          if (section.verificationReqd == "Y") {
            for (const row of section.rowList) {
              if (row.status == "Verified") {
                this.isAllSectionsVerified = true;
              } else {
                this.isAllSectionsVerified = false;
                break;
              }
            }
          }
        }
        if (this.isAllSectionsVerified) {
          this.reportOrNormal = false;
          this.appService.getFormSectionData(this.formObj['formId'],
            0).subscribe((data: any) => {
              console.log("555");
              if (data.length == 0 && this.saveButtonForForm && this.firstFieldsList.length > 0) {
                this.visibleExcelPdfPopupWarning = this.dialog.open(this.excelPdfPopupWarning, this.excelPdfPopupConfig);
              } else {
                this.appService.getFormSectionData(this.formObj['formId'],
                  0).subscribe((data: any) => {
                    console.log("55");
                    if (data.length == 0 && this.saveButtonForForm && this.firstFieldsList.length > 0) {
                      this.visibleExcelPdfPopupWarning = this.dialog.open(this.excelPdfPopupWarning, this.excelPdfPopupConfig);
                    } else {
                      this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
                    }
                  });
              }
            });

        } else {
          this.warningMsg = "Please verify all the sections before " + button;
          this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
        }
      } else {
        this.appService.getFormSectionData(this.formObj['formId'],
          0).subscribe((data: any) => {
            this.reportOrNormal = false;
            if (data.length == 0 && this.saveButtonForForm && this.firstFieldsList.length > 0) {
              this.visibleExcelPdfPopupWarning = this.dialog.open(this.excelPdfPopupWarning, this.excelPdfPopupConfig);
            } else {
              this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
            }
          });
      }

    }
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  deleteReasonValidation() {
    const reason = document.getElementById('reason') as HTMLInputElement;

    const reasonRequiredMsg = document.getElementById('reason-required-msg') as HTMLInputElement;

    if (this.reason == "" || this.reason == null || this.reason == undefined) {

      reason.style.border = '1px solid red';
      reasonRequiredMsg.style.display = 'block';
    } else {
      reason.style.border = 'none';
      reasonRequiredMsg.style.display = 'none';
    }



  }

  confirmWithReasonFunc() {
    this.isProcessing = true;
    if (this.reason == null) {
      this.deleteReasonValidation();
      this.isProcessing = false;
    } else {
      let data = {

        formId: this.formObj['formId'],
        currentStatus: this.formObj['status'],
        stageName: null,
        buttonValue: this.buttonLabel,

        actionStatus: null,
        comments: this.reason,
        rejectReason: "",
        reasonForSignature: "",
        fileExtn: null,
      }
      const formData = new FormData();
      const emptyfile: File | null = null;
      formData.append('file', emptyfile ?? '');
      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('dto', blob);
      this.commomPerformOperationFunc(formData);

    }

  }

  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages


  searchValue: any = "";
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  onTabChanged(event: any) {

  }

  visibleEditButton = false;
  visibleAddButton = false;
  sectionData: any = {};
  addSectionDataFunc(section: any) {
    this.sectionData = section;
    this.sectionData.addRecordLabel ??= this.sectionData.sectionName;
    this.visibleEditButton = false;
    this.visibleAddButton = true;

    this.selectedDoc = {};
    this.model = { documentData: {} };

    for (let i = 0; i < section.fieldsList.length; i++) {
      section.fieldsList[i].fieldDefaultValue = null;
      section.fieldsList[i].selectedFlexifieldValue = [];
      section.fieldsList[i].checkedCheckBoxValue = [];
      if (section.originalFieldsList[i].fieldDefaultValue) {
        section.fieldsList[i].fieldDefaultValue = section.originalFieldsList[i].fieldDefaultValue;
        if (section.fieldsList[i].fieldType == "Vertical Checkbox Button" || section.fieldsList[i].fieldType == "Horizontal Checkbox Button") {
          section.fieldsList[i].checkedCheckBoxValue = section.originalFieldsList[i].fieldDefaultValue.split(",");

        } else if (section.fieldsList[i].fieldType == "Multiselect Drop Down") {
          section.fieldsList[i].selectedFlexifieldValue = section.originalFieldsList[i].fieldDefaultValue.split(",");

        } else if (section.fieldsList[i].fieldType == "Drop Down") {
          for (const dropdown of section.fieldsList[i].dropdowns) {
            if (dropdown.valueExp == section.originalFieldsList[i].fieldDefaultValue) {
              section.fieldsList[i].selectedFlexifieldValue = [{
                valueExp: dropdown.valueExp,
                displayExp: dropdown.displayExp
              }];
            }
          }
        }
      } else {
        if (section.fieldsList[i].fieldDatatype == "Date" || section.fieldsList[i].fieldDatatype == "Datetime") {
          if (section.fieldsList[i].fieldLovValues != null && section.fieldsList[i].fieldLovValues == "Current Date") {
            console.log("*************=", section.originalFieldsList[i].fieldDefaultValue)

            section.fieldsList[i].fieldDefaultValue = new Date();
          }
        }
      }
    }
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  IsViewTabs = false;
 
  editGridData: any = {}; 
  editSectiondata(section: any, rowdata: any) {
    this.sectionData = section;
    this.sectionData.addRecordLabel ??= this.sectionData.sectionName;
    this.editGridData = section.rowList.find((row: any) => row.recordSeq === rowdata[0]);
    
    for (const field of section.fieldsList) {
      let key = this.getColumnName(field.mappingColumn);
      let rawValue = this.editGridData[key];

      // 1. Safe assignment for normal fields
      if (rawValue == null || rawValue === "") {
        field.fieldDefaultValue = null;
      } else if (field.fieldDatatype == "Date" || field.fieldDatatype == "Datetime") {
        try {
          const userTimezone = localStorage.getItem('timezone') || 'Asia/Kolkata';
          const utcDate = new Date(rawValue);
          const localDate = utcToZonedTime(utcDate, userTimezone);
          field.fieldDefaultValue = new Date(localDate);
        } catch (e) {
          console.error("Date parse error:", e);
          field.fieldDefaultValue = null;
        }
      } else {
        field.fieldDefaultValue = rawValue;
      }

      // 2. Safe Parsing for Multi-Values (Prevents .split(",") crashes)
      if (field.fieldType == "Multiselect Drop Down" || field.fieldType == 'Vertical Checkbox Button' || field.fieldType == 'Horizontal Checkbox Button') {
        if (field.fieldDefaultValue != null) {
          // Explicitly cast to string before splitting, and trim whitespace
          const rawStringValues = String(field.fieldDefaultValue).split(",");
          let finalValues: (string | number)[];

          if (field.fieldDatatype == "Number" || field.fieldDatatype == "NUMBER") {
            finalValues = rawStringValues.map(v => Number(v.trim()));
          } else {
            finalValues = rawStringValues.map(v => v.trim());
          }

          if (field.fieldType == "Multiselect Drop Down") {
            field.selectedFlexifieldValue = finalValues;
          } else {
            field.checkedCheckBoxValue = finalValues;
          }
        } else {
          field.selectedFlexifieldValue = [];
          field.checkedCheckBoxValue = [];
        }
      }
    }

    this.visibleEditButton = true;
    this.visibleAddButton = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }
  
  deleteGridData: any = {};
  deleteSectiondata(section: any, rowdata: any) {
    this.sectionData = section;
    this.deleteGridData = section.rowList.find((row: any) => row.recordSeq === rowdata[0]);
    this.reason = "";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  compareDropdownValues(v1: any, v2: any): boolean {
    if (v1 == null && v2 == null) return true;
    if (v1 == null || v2 == null) return false;
    return String(v1).trim() === String(v2).trim();
  }

  isMandatoryFieldsNotEntered = false;
  fieldDataTypeError = false;
  fieldDataTypeErrorLabelName: any;
 addAndEditFunction(sectionData: any) {
    this.isMandatoryFieldsNotEntered = false;
    this.fieldDataTypeError = false;
    //VALIDATION (Runs for both ADD and UPDATE)
 
    for (const field of sectionData.fieldsList) {
      
      // Format arrays to strings before validation
      if (field.fieldType == "Horizontal Checkbox Button" || field.fieldType == "Vertical Checkbox Button") {
        field.fieldDefaultValue = (field.checkedCheckBoxValue && field.checkedCheckBoxValue.length > 0) 
          ? field.checkedCheckBoxValue.join(",") 
          : null;
      } else if (field.fieldType == "Multiselect Drop Down") {
        field.fieldDefaultValue = (field.selectedFlexifieldValue && field.selectedFlexifieldValue.length > 0) 
          ? field.selectedFlexifieldValue.join(",") 
          : null;
      }

      // Handles null, arrays, whitespace, and stringified nulls
      let val = field.fieldDefaultValue;
      let isEmpty = false;

      if (val === null || val === undefined) {
        isEmpty = true;
      } else if (Array.isArray(val) && val.length === 0) {
        isEmpty = true;
      } else if (typeof val === 'string') {
        const trimmed = val.trim();
        if (trimmed === "" || trimmed.toLowerCase() === "null" || trimmed.toLowerCase() === "undefined" || trimmed.toLowerCase() === "select") {
          isEmpty = true;
        }
      }

      if (isEmpty && field.isMandatory === "Y" && field.fieldType !== "Auto Generated Number" && !field.isNotEditable) {
        this.isMandatoryFieldsNotEntered = true;
      }

      if (field.fieldDatatype === "NUMBER" || field.fieldDatatype === "Number") {
        const isNumber = (n: any) => !Number.isNaN(Number.parseFloat(n)) && !Number.isNaN(n - 0);
        if (!isEmpty && !isNumber(val)) {
          this.fieldDataTypeErrorLabelName = field.fieldName;
          this.fieldDataTypeError = true;
        }
      }
    }

    // HALT EXECUTION IF VALIDATION FAILS

    if (this.isMandatoryFieldsNotEntered) {
      this.warningMsg = "Please enter all mandatory fields!";
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
      return; 
    } 
    
    if (this.fieldDataTypeError) {
      this.warningMsg = "Entered invalid data in " + this.fieldDataTypeErrorLabelName;
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
      return; 
    }

    this.isProcessing = true;

    if (this.visibleAddButton) {

      // ADD LOGIC

      let data: any = {};
      data.formId = this.formObj.formId;
      data.sectionId = sectionData.sectionId;
      data.status = "Draft";

      for (const field of sectionData.fieldsList) {
        let key = this.getColumnName(field.mappingColumn);
        if (key.includes("date") || field.fieldDatatype == "Datetime" || field.fieldDatatype == "Date") {
          data[key] = field.fieldDefaultValue ? new Date(field.fieldDefaultValue) : null;
        } else if (field.fieldDatatype == "NUMBER" || field.fieldDatatype == "Number") {
          data[key] = field.fieldDefaultValue ? Number.parseInt(field.fieldDefaultValue) : null;
        } else {
          data[key] = field.fieldDefaultValue;
        }
      }

      this.appService.addSectionData(data).subscribe({
        next: (Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == "S") {
            this.visibleAddAndEditPopup.close();
            this.callSectionData(sectionData);
          }

          let displayMessage = Response.result;
          if (Response.resultType == 'E' && Response.result.includes('The user do not have handle form/verify/withdraw data privileges')) {
            displayMessage = "Action not allowed: This is a preview popup and does not support data entry.";
          }

          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: displayMessage,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });

          sb.onAction().subscribe(() => { sb.dismiss(); });
        }, 
        error: (error) => {
          this.isProcessing = false;
          this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: "An error occurred while processing your request",
              type: 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'Error',
          });
        }
      });

    } else {
      // UPDATE LOGIC
     delete this.editGridData.createdOn;
      delete this.editGridData.updatedOn;
      
      if (this.editGridData.verificationRequestedOn != null) {
        this.editGridData.verificationRequestedOn = new Date(this.editGridData.verificationRequestedOn);
      }
      if (this.editGridData.verifiedOn != null) {
        this.editGridData.verifiedOn = new Date(this.editGridData.verifiedOn);
      }

      this.editGridData.formId = this.formObj.formId;
      this.editGridData.sectionId = sectionData.sectionId;

      for (const field of sectionData.fieldsList) {
        let key = this.getColumnName(field.mappingColumn);

        if (key.includes("date") || field.fieldDatatype == "Datetime" || field.fieldDatatype == "Date") {
          this.editGridData[key] = field.fieldDefaultValue ? new Date(field.fieldDefaultValue) : null;
        } else if (field.fieldDatatype == "NUMBER" || field.fieldDatatype == "Number") {
          this.editGridData[key] = field.fieldDefaultValue ? Number.parseInt(field.fieldDefaultValue) : null;
        } else {
          this.editGridData[key] = field.fieldDefaultValue;
        }
      }
      
      for (let k = 0; 14 >= k; k++) {
        let kk = k + 1;
        if (k >= 9 && this.editGridData["dateColumn" + kk] != null) {
          this.editGridData["dateColumn" + kk] = new Date(this.editGridData["dateColumn" + kk]);
        } else if (9 > k && this.editGridData["dateColumn0" + kk] != null) {
          this.editGridData["dateColumn0" + kk] = new Date(this.editGridData["dateColumn0" + kk]);
        }
      }

      this.appService.updateSectionData(this.editGridData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleAddAndEditPopup.close();
          this.callSectionData(sectionData);
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => { sb.dismiss(); });
      });
    }
  }

  getColumnName(str: string): string {
    let data = str.toLowerCase().split("_");
    for (let i = 1; i < data.length; i++) {
      data[i] = data[i].charAt(0).toUpperCase() + data[i].slice(1);
    }

    return data.join('');
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  onFieldFocusout() {

    if (this.deleteFiledValueRequiredMsg != undefined) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteFormTemplateData: any;
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data: any = {};

      data.formId = this.formObj.formId;
      data.sectionId = this.sectionData.sectionId;
      data.deleteReason = this.reason;
      data.recordId = this.deleteGridData.recordId;
      data.recordSeq = this.deleteGridData.recordSeq;
      this.appService.deleteSectionData(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.callSectionData(this.sectionData);
            this.visibleDeletePopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  selectedStatusValue: any;
  onStatusSelect(item: any) {
    this.selectedStatusValue = item;
    this.changetypeAddAndEditPassword = true;
  }

  onStatusRemoved(item: any) {
    this.selectedStatusValue = "";
  }

  verifierStatus: any;
  onVerifierStatusSelect(status: any) {
    this.verifierStatus = status;
  }

  evidenceFile: any = null;
  onConfirmFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.evidenceFile = file;
      this.buttonOperationFile = file;
      this.fileExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let name = file.name.slice(0, file.name.lastIndexOf('.'));
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "ORG");
      formData.append("fileName", name);
      formData.append("extension", this.fileExtn);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.evidenceFile = data.file;
              this.clearedOperationDoc = false;
            } else {
              this.buttonOperationFile = null;
              this.fileExtn = '';
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        })
    } else {
      this.buttonOperationFile = null;
      this.fileExtn = '';
    }
  }

  clearedOperationDoc = false;
  removeOperationDoc() {
    this.clearedOperationDoc = true;
    this.evidenceFile = null;
    this.fileExtn = null;
  }

  cancelConfirmFunc() {
    this.visibleConfirm.close();
  }

  buttonOperationFile: File | null;

  confirmOkFunc() {
    this.isProcessing = true;
    let data = {
      formId: this.formObj['formId'],
      version: 0,
      currentStatus: this.formObj['status'],
      stageName: this.stageName,
      buttonValue: this.buttonLabel,
      actionStatus: null,
      comments: null,
      rejectReason: "",
      reasonForSignature: "",
    }
    const formData = new FormData();
    formData.append('file', this.buttonOperationFile ?? '');
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('dto', blob);
    this.commomPerformOperationFunc(formData);
  }

  cancelConfirmWithDataFunc() {
    this.visibleConfirmWithData.close();
  }



  isEsignRequired = false;
  password: any = "";
  comments: any = "";
  fileExtn: any = "";
  confirmWithDataFunc() {
    this.isProcessing = true;
    if (this.isEsignRequired) {
      if (localStorage.getItem("adEnabled") == 'Y') {
        this.authEnable("confirmWithDataFunc");
        this.isProcessing = false;
      } else if (this.password == "") {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          userName: this.userName,
          password: this.password,
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.isProcessing = true;
            if (this.selectedStatusValue == "") {
              this.buttonOperationFieldValidation();
              this.isProcessing = false;
            } else {
              let data = {
                formId: this.formObj['formId'],
                version: 0,
                currentStatus: this.formObj['status'],
                stageName: this.stageName,
                buttonValue: this.buttonLabel,

                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: "",
                reasonForSignature: "",
                fileExtn: this.fileExtn,
              }
              const formData = new FormData();
              const emptyfile: File | null = null;
              formData.append('file', this.buttonOperationFile ?? ''); const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('dto', blob);
              this.commomPerformOperationFunc(formData);
            }
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })
      }
    } else {
      this.isProcessing = true;
      if (this.selectedStatusValue == "") {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {

          formId: this.formObj['formId'],
          version: 0,
          currentStatus: this.formObj['status'],
          stageName: this.stageName,
          buttonValue: this.buttonLabel,

          actionStatus: this.selectedStatusValue,
          comments: this.comments,
          rejectReason: "",
          reasonForSignature: "",
          fileExtn: this.fileExtn,
        }
        const formData = new FormData();
        const emptyfile: File | null = null;
        formData.append('file', this.buttonOperationFile ?? '');
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('dto', blob);
        this.commomPerformOperationFunc(formData);
      }
    }
  }
  commomPerformOperationFunc(formData: FormData) {
    this.appService.performButtonOperationForForm(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        if (this.visibleConfirmWithData != undefined) {
          this.visibleConfirmWithData.close();
        }
        if (this.visibleConfirmWithReason != undefined) {
          this.visibleConfirmWithReason.close();
        }
        if (this.visibleConfirm != undefined) {
          this.visibleConfirm.close();
        }
        if (this.visibleSwitchUserPopup != undefined) {
          this.visibleSwitchUserPopup.close();
        }

        this.isProcessing = true;
        this.appService.getFormByFormId(this.formObj.formId)
          .subscribe((data: any) => {
            this.isProcessing = false;
            this.formObj = data[0];
            this.formObj.module = "FORMS"
            if (this.formObj.isFrom == "TEMPLATE") {
              this.saveButtonForForm = true;
            } else {
              this.getButtonLabels();
            }
          })

      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  status: any;
  pass: any;

  statusRequiredMsg: any;
  passRequiredMsg: any;
  buttonOperationFieldValidation() {
    this.status = document.getElementById('status') as HTMLInputElement;
    this.pass = document.getElementById('pass') as HTMLInputElement;

    this.statusRequiredMsg = document.getElementById('status-required-msg') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('pass-required-msg') as HTMLInputElement;


    if (this.selectedStatusValue == "") {
      this.status.style.border = '1px solid red';
      this.statusRequiredMsg.style.display = 'block';
    } else {
      this.status.style.border = 'none';
      this.statusRequiredMsg.style.display = 'none';
    }

    if (this.password == "") {
      this.pass.style.border = '1px solid red';
      this.passRequiredMsg.style.display = 'block';
    } else {
      this.pass.style.border = 'none';
      this.passRequiredMsg.style.display = 'none';
    }


  }

  buttonOperationSwitchUserFieldValidation() {

    const switchUser = document.getElementById('switchUser') as HTMLInputElement;
    const switchUserRequiredMsg = document.getElementById('switchUser-required-msg') as HTMLInputElement;

    const comments = document.getElementById('commentsForSwitchUser') as HTMLInputElement;
    const commentsRequiredMsg = document.getElementById('commentsForSwitchUser-required-msg') as HTMLInputElement;

    if (this.switchedToUser == null) {
      switchUser.style.border = '1px solid red';
      switchUserRequiredMsg.style.display = 'block';
    } else {
      switchUser.style.border = 'none';
      switchUserRequiredMsg.style.display = 'none';
    }

    if (this.comments == null || this.comments == "") {
      comments.style.border = '1px solid red';
      commentsRequiredMsg.style.display = 'block';
    } else {
      comments.style.border = 'none';
      commentsRequiredMsg.style.display = 'none';
    }

  }

  onFlexifieldSelect(field: any, item: any) {
    if (item) {
      field.fieldDefaultValue = item.valueExp;
    } else {
      field.fieldDefaultValue = null;
    }
  }

  onFlexifieldRemoved(item: any) {

  }

  verifier: any;
  verifierReqdMsg: any;
  buttonOperationFieldValidationForSubmitVerify() {
    this.verifier = document.getElementById('verifier') as HTMLInputElement;
    this.verifierReqdMsg = document.getElementById('verifier-required-msg') as HTMLInputElement;


    if (this.selectedVerifier) {
      this.verifier.style.border = 'none';
      this.verifierReqdMsg.style.display = 'none';
    } else {
      this.verifier.style.border = '1px solid red';
      this.verifierReqdMsg.style.display = 'block';
    }
  }

  commentsForVerify: any;
  passForVerify: any;
  verifierStatuscss: any;
  commentsForVerifyRequiredMsg: any;
  passForVerifyRequiredMsg: any;
  verifierStatusRequiredMsg: any;
  buttonOperationFieldValidationForVerify() {
    this.passForVerify = document.getElementById('passwordcss') as HTMLInputElement;
    this.verifierStatuscss = document.getElementById('verifierstatus') as HTMLInputElement;

    this.passForVerifyRequiredMsg = document.getElementById('passwordcss-required-msg') as HTMLInputElement;
    this.verifierStatusRequiredMsg = document.getElementById('verifierstatus-required-msg') as HTMLInputElement;
    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == "") {
        this.passForVerify.style.border = '1px solid red';
        this.passForVerifyRequiredMsg.style.display = 'block';
      } else {
        this.passForVerify.style.border = 'none';
        this.passForVerifyRequiredMsg.style.display = 'none';
      }
    }

    if (this.selectedVerifierStatus == "") {
      this.verifierStatuscss.style.border = '1px solid red';
      this.verifierStatusRequiredMsg.style.display = 'block';
    } else {
      this.verifierStatuscss.style.border = 'none';
      this.verifierStatusRequiredMsg.style.display = 'none';
    }


  }

  verifyData: any = {};
  verifierList: any = [];
  selectedVerifier: any = null;
  titleForSectionVerifyButton: any;
  verifierDropdown: any = [];
  verifyComments: any;
  selectedVerifierStatus: any = "";



  withdrawData: any = {};
  withdrawerList: any = [];
  selectedWithdrawer: any = null;
  titleForSectionWithdrawButton: any;
  withdrawDropdown: any = [];
  withdrawerComments: any;
  selectedWithdrawStatus: any = "";

  templateDataForTable1temp: any;
  setPagedorserch(page: number, targetpage: number, section: any) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.templateDataForTable1temp.length > 0) {
      this.pager = this.paginationService.getPager(this.templateDataForTable1temp.length, page, this.perPage, targetpage);
      this.pagedItems = this.templateDataForTable1temp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  searchValue2: any;
  applyFilter2(event: Event, section: any) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.templateDataForTable1temp = section.dataList;
      this.pager = this.paginationService.getPager(this.templateDataForTable1temp.length, 1, this.perPage, 0);
      this.pagedItems = this.templateDataForTable1temp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (section.dataList == undefined) {
        return section.dataList;
      }
      if (!section.dataList.length) {
        return section.dataList;
      }
      if (filter) {
        this.templateDataForTable1temp = section.dataList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.templateDataForTable1temp = section.dataList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0, section);
    }
  }

  verifierStatusList = ["Verification Completed", "Verification Rejected", "More Info. Required"]
  verifyDataFunc(section: any, rowdata: any) {
    const actualRow = section.rowList.find((row: any) => row.recordSeq === rowdata[0]);
    this.sectionData = section;
    this.verifyData = actualRow;
    this.editGridData = actualRow;

    console.log("this.sectionData=", this.sectionData);
    console.log("this.verifyData=", this.verifyData)
    console.log("this.editGridData=", this.editGridData)
    for (const field of section.fieldsList) {
      const key = this.getColumnName(field.mappingColumn);
      const value = this.editGridData[key];

      if (value == null) {
        field.fieldDefaultValue = null;
        continue;
      }

      if (field.fieldType === "MULTISELECTDROPDOWN") {
        continue;
      }

      if (field.fieldDatatype === "Date" || field.fieldDatatype === "Datetime") {
        field.fieldDefaultValue = new Date(value);
      }
      else {
        field.fieldDefaultValue = value;
      }

      console.log(`fieldDefaultValue for ${key} =`, field.fieldDefaultValue);
    }
    if ((this.verifyData.status == "Draft" || this.verifyData.status == "Verification Rejected"
      || this.verifyData.status == "Verifier Requested More Info.")) {
      this.selectedVerifier = null;
      this.verifierDropdown = [];
      this.appService.getAddedFormUsers(section.templateId, this.verifyData.formId).subscribe((data: any) => {
        this.isProcessing = false;
        this.verifierList = [];
        // 1. Filter and push to verifierList
        const filteredData = data.filter((item: any) => item.verifyFormData === "Y");
        this.verifierList.push(...filteredData);

        // 2. Map the filtered data to the dropdown format and append
        const newDropdownItems = filteredData.map((item: any) => ({
          valueExp: item.userId,
          displayExp: item.userName
        }));
        this.verifierDropdown = this.verifierDropdown.concat(newDropdownItems);

        // 3. Set the selected verifier if it exists in the updated dropdown
        if (this.verifyData.verifiedBy != null) {
          const match = this.verifierDropdown.find((v: any) => v.valueExp === this.verifyData.verifiedBy);
          if (match) {
            this.selectedVerifier = match.valueExp;
          }
        }
      })
      this.titleForSectionVerifyButton = "Submit for Verification";
    } else if (this.verifyData.status == "Pending Verification") {
      this.verifyComments = "";
      this.password = "";
      this.selectedVerifierStatus = "";
      this.userName = localStorage.getItem("loggedUserName");
      this.titleForSectionVerifyButton = "Verify";
      this.changetypeAddAndEditPassword = true;
    }
    this.visibleVerifyPopup = this.dialog.open(this.verifyPopup, this.verifyPopupConfig);
  }

  cancelVerifyFunc() {
    this.visibleVerifyPopup.close();
  }

  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            console.log("inside");
            if (flag == "Verify") {
              this.perfoemVerifyFuncData();

            } else if (flag == "Widthdraw") {
              this.perfoemWithdrawFuncData();

            } else if (flag == "confirmWithDataFunc") {
              console.log("this.selectedStatusValue=", this.selectedStatusValue);
              this.isProcessing = true;
              if (this.selectedStatusValue == "") {
                this.buttonOperationFieldValidation();
                this.isProcessing = false;
              } else {
                let data = {
                  formId: this.formObj['formId'],
                  version: 0,
                  currentStatus: this.formObj['status'],
                  stageName: this.stageName,
                  buttonValue: this.buttonLabel,

                  actionStatus: this.selectedStatusValue,
                  comments: this.comments,
                  rejectReason: "",
                  reasonForSignature: "",
                  fileExtn: this.fileExtn,
                }
                const formData = new FormData();
                const emptyfile: File | null = null;
                formData.append('file', this.buttonOperationFile ?? '');
                const json = JSON.stringify(data);
                const blob = new Blob([json], {
                  type: 'application/json'
                });
                formData.append('dto', blob);
                this.commomPerformOperationFunc(formData);
              }
            }
          } else {
            console.log("outside");
          }
        },
        error: (error) => {
          this.isProcessing = false;
          console.log(error);
        }
      });
  }

  perfoemVerifyFuncData() {
    if (this.verifierStatus == "More Info. Required") {
      this.verifyData.status = "Verifier Requested More Info."
    } else
      if (this.verifierStatus == "Verification Completed") {
        this.verifyData.isVerified = "Y";
        this.verifyData.status = "Verified";
        this.verifyData.verifiedOn = new Date();
      } else {
        this.verifyData.status = this.verifierStatus;
      }
    this.isProcessing = true;
    if (this.selectedVerifierStatus == "") {
      this.buttonOperationFieldValidationForVerify();
      this.isProcessing = false;
    } else {
      delete this.verifyData.createdOn;
      delete this.verifyData.updatedOn;

      this.verifyData.verifierComments = this.verifyComments;
      if (this.verifyData.verificationRequestedOn != null) {
        this.verifyData.verificationRequestedOn = this.convertTZ(this.verifyData.verificationRequestedOn, this.userTimeZone);
      }
      for (const field of this.sectionData.fieldsList) {
        const key = this.getColumnName(field.mappingColumn);
        const val = field.fieldDefaultValue;

        if (field.fieldType === "MULTISELECTDROPDOWN") {
          continue;
        }

        const isDateType = key.includes("date") ||
          field.fieldDatatype === "Datetime" ||
          field.fieldDatatype === "Date";

        if (isDateType) {
          if (val != null) {
            this.verifyData[key] = new Date(val);
          }
        }
        else if (field.fieldDatatype === "NUMBER") {
          this.verifyData[key] = Number.parseInt(val);
        }
        else {
          this.verifyData[key] = val;
        }
      }
      //finall date formate changes
      for (let k = 0; 14 >= k; k++) {
        let kk = k + 1;
        if (k >= 9 && this.verifyData["dateColumn" + kk] != null) {
          this.verifyData["dateColumn" + kk] = new Date(this.verifyData["dateColumn" + kk]);
        } else if (9 > k && this.verifyData["dateColumn0" + kk] != null) {
          this.verifyData["dateColumn0" + kk] = new Date(this.verifyData["dateColumn0" + kk]);
        }
      }
      console.log("this.verifyData=", this.verifyData);
      this.appService.updateSectionData(this.verifyData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleVerifyPopup.close();
          this.callSectionData(this.sectionData);
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })
    }
  }

  convertTZ(dateInput: any, tzString: string) {
    if (!dateInput) return null;

    const date = (dateInput instanceof Date) ? dateInput : new Date(dateInput);
    if (Number.isNaN(date.getTime())) return null; // invalid date check

    const diff = date.getTime() - new Date(date.toLocaleString("en-US", { timeZone: tzString })).getTime();
    return new Date(date.getTime() + diff);
  }
  perfomrVerifyFunc() {
    console.log("this.sectionData=", this.sectionData);
    console.log("this.verifyData=", this.verifyData)
    console.log("this.editGridData=", this.editGridData)
    if (this.titleForSectionVerifyButton == "Verify") {
      this.isProcessing = true;
      if (localStorage.getItem("adEnabled") == 'Y') {
        this.authEnable("Verify");
      } else if (localStorage.getItem("adEnabled") != 'Y' && this.password == "") {
        this.buttonOperationFieldValidationForVerify();
        this.isProcessing = false;
      } else {
        let data = {
          userName: this.userName,
          password: this.password,
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.perfoemVerifyFuncData();
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })
      }
    } else {
      this.isProcessing = true;
      if (this.selectedVerifier) {
        delete this.verifyData.createdOn;
        delete this.verifyData.updatedOn;

        this.verifyData.verifiedBy = this.selectedVerifier ?? null;
        this.verifyData.status = "Pending Verification";
        if (this.verifyData.verifiedOn != null) {
          this.verifyData.verifiedOn = this.convertTZ(this.verifyData.verifiedOn, this.userTimeZone);
        }

        this.verifyData.verificationRequestedOn = new Date();
        console.log("1", this.sectionData.fieldsList.length)
        for (const field of this.sectionData.fieldsList) {
          const key = this.getColumnName(field.mappingColumn);
          const val = field.fieldDefaultValue;

          // Initial log exactly as you had it
          console.log(`${key.includes("date")}==1==${field.fieldDatatype}`);

          if (key.includes("date")) {
            console.log("1");
            if (val != null) {
              this.verifyData[key] = new Date(val);
              console.log("4=", this.verifyData[key]);
            }
          }
          else if (field.fieldDatatype === "Datetime" || field.fieldDatatype === "Date") {
            if (val != null) {
              this.verifyData[key] = new Date(val);
              console.log("3=", this.verifyData[key]);
            }
            console.log("2");
          }
          else if (field.fieldDatatype === "NUMBER") {
            this.verifyData[key] = Number.parseInt(val);
          }
          else if (field.fieldType === "MULTISELECTDROPDOWN") {
            continue;
          }
          else {
            this.verifyData[key] = val;
          }
        }
        //finall date formate changes
        for (let k = 0; 14 >= k; k++) {
          let kk = k + 1;
          if (k >= 9 && this.verifyData["dateColumn" + kk] != null) {
            this.verifyData["dateColumn" + kk] = new Date(this.verifyData["dateColumn" + kk]);
          } else if (9 > k && this.verifyData["dateColumn0" + kk] != null) {
            this.verifyData["dateColumn0" + kk] = new Date(this.verifyData["dateColumn0" + kk]);
          }
        }
        console.log("this.verifyData=", this.verifyData);
        this.appService.updateSectionData(this.verifyData).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == "S") {
            this.visibleVerifyPopup.close();
            this.callSectionData(this.sectionData);
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        })
      } else {
        this.buttonOperationFieldValidationForSubmitVerify();
        this.isProcessing = false;
      }
    }


  }

  removeDocRep(field: any) {
    if (!this.canModifyDocument) {
      return;
    }
    field.fieldDefaultValue = null;  // Clear selectedDoc only if it's related to this field
    if (this.documentSearchField === field) {
      this.selectedDoc = null;
    }

  }

  documentSearchField: any;
  searchDocumentFunction(field: any) {
    if (!this.canModifyDocument) {
      this.warningMsg = "You must Self-Lock this form to upload documents.";
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
      return;
    }
    this.documentSearchField = field;
    this.visibleSearchDocumentPopup = this.dialog.open(this.searchDocument, this.searchDocumentConfig);

  }

  model = {
    documentData: {},
  };
  selectedDoc: any = {};

  changeInFolderStructureChild(data: any) {
    this.model = data;
    this.selectedDoc = this.model.documentData;
  }

  addDocumentFunction() {

    if (this.selectedDoc?.folderPath &&
      this.selectedDoc?.documentNo &&
      this.selectedDoc?.documentName &&
      this.selectedDoc?.documentExtn) {

      this.documentSearchField.fieldDefaultValue =
        this.selectedDoc.folderPath + ">" +
        this.selectedDoc.documentNo + "(" +
        this.selectedDoc.documentName + "." +
        this.selectedDoc.documentExtn + ")";

      this.visibleSearchDocumentPopup.close();
    } else {

      this.warningMsg = "Please select a document before adding.";
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
    }
  }

  cancelSearchDocumentFunction() {
    this.visibleSearchDocumentPopup.close();
  }


  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;


  ui_case(label: any) {
    return label.split(' ').map((word: any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  }

  openAuditTrail(viewType: any, form: any, param: any) {




    this.message.tableOrView_Name = "ONEQMS_FORM_SECTION_DATA_AU_VW";
    let db_1 = "CREATED_TS,END_TS,ACTION_FLAG,RECORD_SEQ";
    let db_2 = form?.verificationReqd == 'Y' ? ",STATUS,IS_VERIFIED,VERIFICATION_REQUESTED_ON,VERIFIED_BY_USER,VERIFIED_ON,VERIFIER_COMMENTS," : ",";
    let db_21 = form?.withdrawalReqd == 'Y' ? "IS_WITHDRAWN,WITHDRAWAL_REQUESTED_ON,WITHDRAWN_BY_USER,WITHDRAWN_ON,WITHDRAWER_COMMENTS," : "";
    let db_3 = viewType == 'detail' ? form.map((item: any) => item.mappingColumn).join(',') : form?.columnList?.map((item: any) => item?.mappingColumn?.toString()).filter(Boolean).join(',') ?? "";
    let db_4 = (db_3 ? "," : "") + "CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER" + (viewType == 'detail' ? "" : ",DELETED_BY_USER,DELETED_REASON");
    this.message.columnList_DB = `${db_1}${db_2}${db_21}${db_3}${db_4}`;

    let ui_1 = "Created Timestamp,End Timestamp,Action,Seq";
    let ui_2 = form?.verificationReqd == 'Y' ? ",Status,Is Verified,Verification Requested On,Verified By,Verified On,Verifier Comments," : ",";
    let ui_21 = form?.withdrawalReqd == 'Y' ? "Is Withdrawn,Withdrawal Requested On,Withdrawer,Withdrawn Action Taken On,Withdrawer Comments," : "";

    let ui_3 = viewType == 'detail' ? form.map((item: any) => this.ui_case(item.fieldName)).join(',') : form.columnList?.filter((item: any) => item.fieldName !== 'Seq').map((item: any) => this.ui_case(item.fieldName)).join(',') ?? "";
    let ui_4 = (ui_3 ? "," : "") + "Created On,Created By,Updated On,Updated By" + (viewType == 'detail' ? "" : ",Deleted By,Deleted Reason");
    this.message.columnList_UI = `${ui_1}${ui_2}${ui_21}${ui_3}${ui_4}`;

    let recordId: string | null = null;
    if (viewType === 'detail') recordId = this.firstFormObj.recordId;
    else if (viewType === 'individual') {
      const actualRow = form.rowList.find((row: any) => row.recordSeq === param[0]);
      recordId = actualRow ? actualRow.recordId : null;
    }
    let record = recordId ? ` AND RECORD_ID = ${recordId}` : '';
    let section = viewType == 'detail' ? form[0].sectionId : form.sectionId;
    this.message.whereClause_AU = ` AND FORM_ID = ${this.formObj.formId}${record} AND SECTION_ID = ${section}`;

    let report_1 = "Created Timestamp,End Timestamp,Action,Seq";
    let report_2 = form?.verificationReqd == 'Y' ? ",Status,Is Verified,Verification Requested On,Verified By,Verified On,Verifier Comments," : ",";
    let report_21 = form?.withdrawalReqd == 'Y' ? "Is Withdrawn,Withdrawal Requested On,Withdrawer,Withdrawn Action Taken On,Withdrawer Comments," : "";

    let report_3 = viewType == 'detail' ? form.map((item: any) => this.ui_case(item.fieldName)).join(',') : form.columnList?.filter((item: any) => item.fieldName !== 'Seq').map((item: any) => this.ui_case(item.fieldName)).join(',') ?? "";
    let report_4 = (report_3 ? "," : "") + "Created On,Created By,Updated On,Updated By" + (viewType == 'detail' ? "" : ",Deleted By,Deleted Reason");
    this.message.sectionId = form.sectionId;
    this.message.templateId = this.formObj.templateId;
    this.message.columnList_Report = `${report_1}${report_2}${report_21}${report_3}${report_4}`;
    this.message.whereClause_Report = ` WHERE FORM_ID = ${this.formObj.formId}${record} AND SECTION_ID = ${section}`;
    this.message.report_And_Popup_Name = "Forms " + (form.sectionName ? form.sectionName : this.formObj.formName) + " Audit Trail";

    this.staticAuditTrailComponent.triggerTrail(form);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string, viewType: any, form: any, param: any) {
    let db_1 = "RECORD_SEQ";
    let db_2 = form?.verificationReqd == 'Y' ? ",STATUS,IS_VERIFIED,VERIFICATION_REQUESTED_ON,VERIFIED_BY_USER,VERIFIED_ON,VERIFIER_COMMENTS," : ",";
    let db_21 = form?.withdrawalReqd == 'Y' ? "IS_WITHDRAWN,WITHDRAWAL_REQUESTED_ON,WITHDRAWN_BY_USER,WITHDRAWN_ON,WITHDRAWER_COMMENTS," : "";

    let db_3 = viewType == 'detail' ? form.map((item: any) => item.mappingColumn).join(',') : form?.columnList?.map((item: any) => item?.mappingColumn?.toString()).filter(Boolean).join(',') ?? "";
    let db_4 = (db_3 ? "," : "") + "CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";

    let report_1 = "Seq";
    let report_2 = form?.verificationReqd == 'Y' ? ",Status,Is Verified,Verification Requested On,Verified By,Verified On,Verifier Comments," : ",";
    let report_21 = form?.withdrawalReqd == 'Y' ? "Is Withdrawn,Withdrawal Requested On,Withdrawer,Withdrawn Action Taken On,Withdrawer Comments," : "";
    let report_3 = viewType == 'detail' ? form.map((item: any) => this.ui_case(item.fieldName)).join(',') : form.columnList?.filter((item: any) => item.fieldName !== 'Seq').map((item: any) => this.ui_case(item.fieldName)).join(',') ?? "";
    let report_4 = (report_2 ? "," : "") + "Created On,Created By,Updated On,Updated By";

    let recordId: string | null = null;
    if (viewType === 'detail') recordId = this.firstFormObj.recordId;
    else if (viewType === 'individual') {
      const actualRow = form.rowList.find((row: any) => row.recordSeq === param[0]);
      recordId = actualRow ? actualRow.recordId : null;
    }
    let record = recordId ? ` AND RECORD_ID = ${recordId}` : '';
    let section = viewType == 'detail' ? form[0].sectionId : form.sectionId;

    this.excelPdf.tableOrView_Name = "ONEQMS_FORM_SECTION_DATA_VW";
    this.excelPdf.columnList_DB = `${db_1}${db_2}${db_21}${db_3}${db_4}`;
    this.excelPdf.columnList_Report = `${report_1}${report_2}${report_21}${report_3}${report_4}`;
    this.excelPdf.whereClause_Report = ` WHERE FORM_ID = ${this.formObj.formId}${record} AND SECTION_ID = ${section}`;
    this.excelPdf.reportType = 'Static';
    this.excelPdf.sectionId = form.sectionId;
    this.excelPdf.templateId = this.formObj.templateId;
    this.excelPdf.reportName = "Forms " + (form.sectionName ? form.sectionName : this.formObj.formName) + " Report";
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('excelPdfPopupWarning', { static: true }) excelPdfPopupWarning: TemplateRef<any>;
  visibleExcelPdfPopupWarning: MatDialogRef<TemplateRef<any>>;
  excelPdfPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }

  popupDataTitle: PopupData = { title: '' };
  isForExcel: boolean = false;
  pdfPageSizes: any = [];
  selectedPdfPageSize: any;
  openReportPopupWarning(reportType: any) {
    this.isForExcel = reportType == 'Excel';
    this.reportOrNormal = true;
    this.appService.getFormSectionData(this.formObj['formId'],
      0).subscribe((data: any) => {
        if (data.length == 0 && this.saveButtonForForm && this.firstFieldsList.length > 0) {

          this.visibleExcelPdfPopupWarning = this.dialog.open(this.excelPdfPopupWarning, this.excelPdfPopupConfig);
        } else {

          this.openReportPopup(reportType);
        }
      });
  }

  cancelReportPopupWarning() {
    this.visibleExcelPdfPopupWarning.close();
  }

  openReportPopup(reportType: any) {
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') || '{}');
    this.selectedPdfPageSize = 'A3';
    this.popupDataTitle.title = reportType == 'Excel' ? 'Excel Report' : 'Pdf Report';
    this.isForExcel = reportType == 'Excel';
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + new Date();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
    this.isTemplateRequired = false;
    this.isReviewApproveRequired = false;
  }

  generateReport(reportType: any) {
    let reportData = {

      formId: this.formObj.formId,
      "logoId": this.selectedReportLogoValue ?? null,
      "isSaveRep": this.isSaveReport ? 'Y' : 'N',
      "isTemplateRequired": this.isTemplateRequired ? 'Y' : 'N',
      "isReviewApproveRequired": this.isReviewApproveRequired ? 'Y' : 'N',
      "reportName": this.reportName ?? "FORMS_Report",
      "Exported By": sessionStorage.getItem("reportsUserName"),
      "currentStatus": "NA",
      "groupName": this.formObj.formName,
      "module": "FL",
      templateId: this.formObj.templateId,
      pdfPageSize: this.selectedPdfPageSize
    }

    if (reportType == 'Excel') {
      this.isProcessing = true;
      this.appService.formsLogsExportReport(reportData, this.formObj.formName + ".xlsx");

      this.isProcessing = false;
    } else {
      this.isProcessing = true;
      this.appService.formsLogsExportReportpdf(reportData, this.formObj.formName + ".pdf");

      this.isProcessing = false;
    }
  }

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
  }

  okInfo() {
    this.visibleInfoPopup.close();
  }

  @ViewChild('viewPopup', { static: true }) viewPopup: TemplateRef<any>;
  visibleViewPopup: MatDialogRef<TemplateRef<any>>;

  viewPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  viewerData: any = {};
  viewDocFromLink(event: any, value: any) {
    event.preventDefault();
    this.visibleViewPopup = this.dialog.open(this.viewPopup, this.viewPopupConfig);
    let val = value.split(">");
    let newVal = val[val.length - 1].split("(");
    let documentNo = newVal[0];
    this.isProcessing = true;
    this.appService.getDocumentsToViewForDmsOnlyByNo(documentNo)
      .subscribe((response: any) => {
        this.isProcessing = false;
        const MIME_TYPE_MAP: Record<string, string> = {
          "application/plain": "log",
          "text/plain": "txt",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
          "application/msword": "doc",
          "application/vnd.ms-excel": "xls",
          "application/vnd.ms-excel.sheet.macroEnabled.12": "xlsm",
          "application/vnd.ms-powerpoint": "ppt",
          "application/zip": "zip",
          "text/xml": "xml",
          "video/mp4": "mp4",
          "image/x-png": "png",
          "image/jpeg": "jpeg"
        };

        const header = response.headers.get('content-type');

        const extension = MIME_TYPE_MAP[header] ?? "pdf";

        console.log(header);

        this.viewerData = {
          body: response.body,
          contentType: header,
          extn: extension
        };
        console.log(header);
      })
  }

  cancelViewPopup() {
    this.visibleViewPopup.close();
  }

  fieldsSearchTxt: string = '';
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  switchUserConfirmFunc() {
    this.isProcessing = true;
    if (this.switchedToUser == null || this.comments == null || this.comments == "") {
      this.buttonOperationSwitchUserFieldValidation();
      this.isProcessing = false;
    } else {


      let data: any = {

        formId: this.formObj['formId'],
        version: 0,
        currentStatus: this.formObj['status'],
        buttonValue: this.buttonLabel,

        actionStatus: this.selectedStatusValue,
        switchedToUser: this.switchedToUser,
        comments: this.comments,
        rejectReason: "",
        reasonForSignature: "",
        fileExtn: this.fileExtn,
      }
      if (this.buttonLabel !== 'Switch User') {
        data.stageName = this.stageName;
      }
      const formData = new FormData();
      const emptyfile: File | null = null;
      formData.append('file', this.buttonOperationFile ?? '');
      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('dto', blob);
      this.commomPerformOperationFunc(formData);
    }
  }

  cancelSwitchUserFunc() {
    this.visibleSwitchUserPopup.close();
  }

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  isTemplateRequired: boolean = false;
  isReviewApproveRequired: boolean = false;
  reportName: any;
  pdfDetailSearchText: string = '';
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    const data = this.dropDownDataForReportLogo;

    if (!data) {
      this.selectedReportLogoValue = [];
      return;
    }

    const imageMap = new Map<string, any>(
      this.organizationReportImageDetails.map((img: any) => [String(img.reportImageId), img])
    );

    const reportList: string = data.reportImageList;

    if (reportList === 'Default') {
      this.reportLogoDropdown.push({ valueExp: 0, displayExp: 'Default' });
    }
    else {
      const ids = reportList.includes(',') ? reportList.split(',') : [reportList];

      ids.forEach((id: string, index: number) => {
        if (index === 0 && id === 'Default') {
          this.reportLogoDropdown.push({ valueExp: 0, displayExp: 'Default' });
        } else {
          const match = imageMap.get(id);
          if (match) {
            this.reportLogoDropdown.push({
              valueExp: match.reportImageId,
              displayExp: match.reportImageName
            });
          }
        }
      });
    }

    const hasValidDefault = data.defaultReportName && data.defaultReportName !== 'Default';

    if (hasValidDefault) {
      const match = this.reportLogoDropdown.find((opt: any) => opt.valueExp == data.defaultReportName);
      if (match) {
        this.selectedReportLogoValue = match.valueExp;
      }
    } else {
      this.selectedReportLogoValue = this.reportLogoDropdown[0]?.valueExp;
    }
  }

  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild(HomepagetagComponent) homepagetagComponent!: HomepagetagComponent;
  openTag() {
    let data = {
      pageName: 'FORMS',
      labelName: "Tag",
      tagRef: this.formObj.formName,
      taskId: this.formObj.formId,
    };
    this.homepagetagComponent.openpopup(data);
  }


  onTagChildValueEmitted() {
    console.log();
  };

  @ViewChild('formUserPopup', { static: true }) formUserPopup: TemplateRef<any>;
  visibleFormUserPopup: MatDialogRef<TemplateRef<any>>;
  formUserPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  addFormusersFunc(form: any, event: any) {
    this.formObj.module = "FORMS";
    this.visibleFormUserPopup = this.dialog.open(this.formUserPopup, this.formUserPopupConfig);
  }

  cancelFormUserFunction() {
    this.visibleFormUserPopup.close();
  }
  autoFillFuction(val: any, i: any) {
    console.log("val", val);
    this.appService.getAutofillFormulaValues(

      val.fieldId
    )
      .subscribe({
        next:
          (response: any) => {
            console.log("response", response);

            // Ensure response is correctly handled
            if (typeof response === 'string') {
              this.firstFieldsList[i].fieldDefaultValue = response; // Assign directly
            } else if (typeof response === 'object' && response !== null) {
              this.firstFieldsList[i].fieldDefaultValue = JSON.stringify(response); // Convert to string
            } else {
              console.error("Unexpected response format", response);
            }
          }, error:
          (error) => {
            console.error("API Error:", error);
          }
      }
      );
  }
  autoFillFuctionSection(val: any, i: any) {
    console.log("val", val);
    this.appService.getAutofillFormulaValues(

      val.fieldId
    )
      .subscribe({
        next:
          (response: any) => {
            console.log("response", response);
            this.sectionData.fieldsList[i].fieldDefaultValue = null;
            // Ensure response is correctly handled
            if (typeof response === 'string') {
              this.sectionData.fieldsList[i].fieldDefaultValue = response; // Assign directly
            } else if (typeof response === 'object' && response !== null) {
              this.sectionData.fieldsList[i].fieldDefaultValue = JSON.stringify(response); // Convert to string
            } else {
              console.error("Unexpected response format", response);
            }
          }, error:
          (error) => {
            console.error("API Error:", error);
          }
      }
      );
  }
  autoFillFuctionSectionDate(val: any, i: any, formOrSection: any) {
    if (formOrSection == 'form') {
      this.firstFieldsList[i].fieldDefaultValue = new Date();
    } else if (formOrSection == 'section') {
      this.sectionData.fieldsList[i].fieldDefaultValue = new Date();
    }
  }
  async validateMandatorySectionFields(): Promise<boolean> {
    const formId = this.formObj?.formId;

    if (!formId) {
      console.error('Missing required context');
      this.warningMsg = 'Form context missing. Please reload.';
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
      return false;
    }

    try {
      // Fetch section template (metadata)
      const templateResponse = await lastValueFrom(
        this.appService
          .getFormSectionTemplateById(this.formObj.templateId, formId)
          .pipe(
            catchError(err => {
              console.error('API Error - getFormSectionTemplateByFormId:', err);
              return of(null);
            })
          )
      );

      if (!templateResponse || !Array.isArray(templateResponse)) {
        console.warn('No valid template data received.');
        return true; // No sections to validate
      }

      // Extract all mandatory fields from all sections
      const mandatoryFields: Array<{
        fieldName: string;
        fieldId: number;
        mappingColumn: string;
        sectionName: string;
        sectionId: number;
      }> = [];

      templateResponse.forEach((section: any) => {
        if (!section.fieldsList || !Array.isArray(section.fieldsList)) return;

        const mandatoryInSection = section.fieldsList
          .filter((field: any) =>
            field.isMandatory === "Y" &&
            field.isNotEditable !== "Y" &&
            field.fieldType !== "Auto Generated Number" // Exclude auto generated fields
          )
          .map((field: any) => ({
            fieldName: field.fieldName,
            fieldId: field.fieldId,
            mappingColumn: field.mappingColumn,
            sectionName: section.sectionName?.trim() || 'Unnamed Section',
            sectionId: section.sectionId
          }));

        mandatoryFields.push(...mandatoryInSection);
      });

      console.log('🔍 Mandatory Fields to Validate:', mandatoryFields);

      if (mandatoryFields.length === 0) {
        console.log('✅ No mandatory section fields found.');
        return true;
      }

      // Validate that we have the template fields logic working
      console.log('Template fields validation completed successfully');
      return true;

    } catch (error) {
      console.error('❌ Error validating mandatory fields:', error);
      this.warningMsg = 'Failed to validate form. Please try again or contact support.';
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
      return false;
    }
  }



  withdrawStatusList = ["Withdrawal Completed", "Withdrawal Rejected", "More Info. Required"]
  withdrawDataFunc(section: any, rowdata: any) {
    const actualRow = section.rowList.find((row: any) => row.recordSeq === rowdata[0]);
    this.sectionData = section;
    this.verifyData = actualRow;
    this.editGridData = actualRow;
    for (const field of section.fieldsList) {
      const key = this.getColumnName(field.mappingColumn);
      const rawValue = this.editGridData[key];

      if (rawValue == null) {
        field.fieldDefaultValue = null;
      }
      else if (field.fieldType === "MULTISELECTDROPDOWN") {
        // Logic intentionally left blank to match original code
      }
      // 3. Handle Date conversions
      else if (field.fieldDatatype === "Date" || field.fieldDatatype === "Datetime") {
        field.fieldDefaultValue = new Date(rawValue);
      }
      else {
        field.fieldDefaultValue = rawValue;
      }

      console.log(`section.fieldsList.fieldDefaultValue for ${key} =`, field.fieldDefaultValue);
    }


    if ((this.verifyData.status == "Verified" || this.verifyData.status == "Withdrawal Rejected"
      || this.verifyData.status == "Withdrawer Requested More Info.")) {
      this.selectedWithdrawer = null;
      this.withdrawDropdown = [];
      this.appService.getAddedFormUsers(section.templateId, this.verifyData.formId).subscribe((data: any) => {
        this.isProcessing = false;
        this.withdrawerList = [];
        const newWithdrawers = data.filter((item: any) => item.withdrawFormData === "Y");
        this.withdrawerList.push(...newWithdrawers);

        const dropdownItems = newWithdrawers.map((item: any) => ({
          valueExp: item.userId,
          displayExp: item.userName
        }));
        this.withdrawDropdown = this.withdrawDropdown.concat(dropdownItems);

        const withdrawById = this.verifyData.withdrawBy;
        if (withdrawById != null) {
          const match = this.withdrawDropdown.find((opt: any) => opt.valueExp == withdrawById);
          if (match) {
            this.selectedWithdrawer = match.valueExp;
          }
        }
      })
      this.titleForSectionWithdrawButton = "Submit for Withdrawal";
    } else if (this.verifyData.status == "Pending Withdrawal") {
      this.withdrawerComments = "";
      this.password = "";
      this.selectedWithdrawStatus = "";
      this.userName = localStorage.getItem("loggedUserName");
      this.titleForSectionWithdrawButton = "Withdraw";
      this.changetypeAddAndEditPassword = true;
    }


    this.visibleWithdrawPopup = this.dialog.open(this.withdrawPopup, this.verifyPopupConfig);
  }

  cancelWithdrawFunc() {
    this.visibleWithdrawPopup.close();
  }

  withdrawerStatus: any;
  onWithdrawStatusSelect(status: any) {
    this.withdrawerStatus = status;
  }


  perfomrWithdrawFunc() {

    if (this.titleForSectionWithdrawButton == "Withdraw") {
      this.isProcessing = true;
      const isAdEnabled = localStorage.getItem("adEnabled") == 'Y';

      if (this.selectedWithdrawStatus == "" || (!isAdEnabled && this.password == "")) {
        this.buttonOperationFieldValidationForWithdraw();
        this.isProcessing = false;
      } else if (isAdEnabled) {
        this.authEnable("Withdraw");
      } else {
        let data = {
          userName: this.userName,
          password: this.password,
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.perfoemWithdrawFuncData();
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })
      }
    } else {
      this.isProcessing = true;
      if (this.selectedWithdrawer) {
        delete this.verifyData.createdOn;
        delete this.verifyData.updatedOn;

        this.verifyData.withdrawnBy = this.selectedWithdrawer ?? null;
        this.verifyData.status = "Pending Withdrawal";
        if (this.verifyData.withdrawOn != null) {
          this.verifyData.withdrawOn = this.convertTZ(this.verifyData.withdrawOn, this.userTimeZone);
        }

        this.verifyData.withdrawalRequestedOn = new Date();
        console.log("1", this.sectionData.fieldsList.length)
        for (const field of this.sectionData.fieldsList) {
          const key = this.getColumnName(field.mappingColumn);
          const val = field.fieldDefaultValue;

          console.log(`${key.includes("date")}==1==${field.fieldDatatype}`);

          if (key.includes("date")) {
            console.log("1");
            if (val != null) {
              this.verifyData[key] = new Date(val);
              console.log("4=", this.verifyData[key]);
            }
          }
          else if (field.fieldDatatype === "Datetime" || field.fieldDatatype === "Date") {
            if (val != null) {
              this.verifyData[key] = new Date(val);
              console.log("3=", this.verifyData[key]);
            }
            console.log("2");
          }
          else if (field.fieldDatatype === "NUMBER") {
            this.verifyData[key] = Number.parseInt(val);
          }
          else if (field.fieldType === "MULTISELECTDROPDOWN") {
            continue;
          }
          else {
            this.verifyData[key] = val;
          }
        }
        //finall date formate changes
        for (let k = 0; 14 >= k; k++) {
          let kk = k + 1;
          if (k >= 9 && this.verifyData["dateColumn" + kk] != null) {
            this.verifyData["dateColumn" + kk] = new Date(this.verifyData["dateColumn" + kk]);
          } else if (9 > k && this.verifyData["dateColumn0" + kk] != null) {
            this.verifyData["dateColumn0" + kk] = new Date(this.verifyData["dateColumn0" + kk]);
          }
        }
        console.log("this.verifyData=", this.verifyData);
        this.appService.updateSectionData(this.verifyData).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == "S") {
            this.visibleWithdrawPopup.close();
            this.callSectionData(this.sectionData);
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        })
      } else {
        this.buttonOperationFieldValidationForSubmitWithdraw();
        this.isProcessing = false;
      }
    }
  }
  withdrawer: any;
  withdrawerReqdMsg: any;
  buttonOperationFieldValidationForSubmitWithdraw() {
    this.withdrawer = document.getElementById('withdrawer') as HTMLInputElement;
    this.withdrawerReqdMsg = document.getElementById('withdrawer-required-msg') as HTMLInputElement;
    if (this.selectedWithdrawer) {
      this.withdrawer.style.border = 'none';
      this.withdrawerReqdMsg.style.display = 'none';
    } else {
      this.withdrawer.style.border = '1px solid red';
      this.withdrawerReqdMsg.style.display = 'block';
    }
  }

  commentsForWithdraw: any;
  passForWithdraw: any;
  withdrawerstatus: any;
  commentsForWithdrawRequiredMsg: any;
  passForWithdrawRequiredMsg: any;
  withdrawerStatusRequiredMsg: any;
  buttonOperationFieldValidationForWithdraw() {
    this.passForWithdraw = document.getElementById('withdrawPassword') as HTMLInputElement;
    this.withdrawerstatus = document.getElementById('withdrawerstatus') as HTMLInputElement;

    this.passForWithdrawRequiredMsg = document.getElementById('withdrawPassword-required-msg') as HTMLInputElement;
    this.withdrawerStatusRequiredMsg = document.getElementById('withdrawerstatus-required-msg') as HTMLInputElement;

    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == "") {
        if (this.passForWithdraw) this.passForWithdraw.style.border = '1px solid red';
        if (this.passForWithdrawRequiredMsg) this.passForWithdrawRequiredMsg.style.display = 'block';
      } else {
        if (this.passForWithdraw) this.passForWithdraw.style.border = 'none';
        if (this.passForWithdrawRequiredMsg) this.passForWithdrawRequiredMsg.style.display = 'none';
      }
    }

    // BUG FIX: Was incorrectly checking this.selectedVerifierStatus
    if (this.selectedWithdrawStatus == "") {
      if (this.withdrawerstatus) this.withdrawerstatus.style.border = '1px solid red';
      if (this.withdrawerStatusRequiredMsg) this.withdrawerStatusRequiredMsg.style.display = 'block';
    } else {
      if (this.withdrawerstatus) this.withdrawerstatus.style.border = 'none';
      if (this.withdrawerStatusRequiredMsg) this.withdrawerStatusRequiredMsg.style.display = 'none';
    }
  }
  perfoemWithdrawFuncData() {
    if (this.withdrawerStatus == "More Info. Required") {
      this.verifyData.status = "Withdrawer Requested More Info."
    } else
      if (this.withdrawerStatus == "Withdrawal Completed") {
        this.verifyData.isWithdraw = "Y";
        this.verifyData.status = "Withdrawn";
        this.verifyData.withdrawOn = new Date();
      } else {
        this.verifyData.status = this.withdrawerStatus;
      }
    this.isProcessing = true;
    if (this.selectedWithdrawStatus == "") {
      this.buttonOperationFieldValidationForWithdraw();
      this.isProcessing = false;
    } else {
      delete this.verifyData.createdOn;
      delete this.verifyData.updatedOn;

      this.verifyData.withdrawerComments = this.withdrawerComments;
      if (this.verifyData.withdrawalRequestedOn) {
        this.verifyData.withdrawalRequestedOn = this.convertTZ(this.verifyData.withdrawalRequestedOn, this.userTimeZone);
      }
      for (const field of this.sectionData.fieldsList) {
        const key = this.getColumnName(field.mappingColumn);
        const val = field.fieldDefaultValue;

        if (field.fieldType === "MULTISELECTDROPDOWN") {
          continue;
        }

        // 2. Consolidate Date Handling
        const isDate = key.includes("date") ||
          field.fieldDatatype === "Datetime" ||
          field.fieldDatatype === "Date";

        if (isDate) {
          if (val != null) {
            this.verifyData[key] = new Date(val);
          }
        }
        // 3. Handle Numbers
        else if (field.fieldDatatype === "NUMBER") {
          this.verifyData[key] = Number.parseInt(val);
        }
        // 4. Default assignment for everything else
        else {
          this.verifyData[key] = val;
        }
      }
      //finall date formate changes
      for (let k = 0; 14 >= k; k++) {
        let kk = k + 1;
        if (k >= 9 && this.verifyData["dateColumn" + kk] != null) {
          this.verifyData["dateColumn" + kk] = new Date(this.verifyData["dateColumn" + kk]);
        } else if (9 > k && this.verifyData["dateColumn0" + kk] != null) {
          this.verifyData["dateColumn0" + kk] = new Date(this.verifyData["dateColumn0" + kk]);
        }
      }
      console.log("this.verifyData=", this.verifyData);
      this.appService.updateSectionData(this.verifyData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleWithdrawPopup.close();
          this.callSectionData(this.sectionData);
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })
    }
  }
  @ViewChild('switchUserChild') switchUserChild: SwitchuserComponent;

  // Variables to hold context for the update
  switchVerifierRowData: any;
  switchVerifierSectionData: any;

  // 1. Updated Open Function
  openSwitchVerifierPopup(section: any, rowdata: any) {
    this.switchVerifierSectionData = section;
    this.switchVerifierRowData = section.rowList.find((row: any) => row.recordSeq === rowdata[0]);

    this.dropdownForSwitchUsers = [];
    this.isProcessing = true;

    const isVerification = this.switchVerifierRowData.status === 'Pending Verification';
    const roleName = isVerification ? 'Verifier' : 'Withdrawer';

    this.appService.getAddedFormUsers(

      section.templateId,
      this.switchVerifierRowData.formId
    ).subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        let userList = [];

        const propertyToMatch = isVerification ? 'verifyFormData' : 'withdrawFormData';

        const matches = data.filter((item: any) => item[propertyToMatch] === 'Y');
        userList.push(...matches);


        if (this.switchUserChild) {
          this.message.switchUserdropDownList = userList.map((u: any) => ({
            valueExp: u.userId,
            displayExp: u.userName
          }));
          this.message.switchUserCurrentValue = isVerification
            ? this.switchVerifierRowData.verifiedBy
            : this.switchVerifierRowData.withdrawnBy;
          this.message.activityId = this.switchVerifierRowData.sectionId;
          this.message.submodule = 'FL Sections';
          this.message.subModuleId = this.switchVerifierRowData.recordId;
          this.message.switchedUser = null;
          this.switchUserChild.openswitchuser(roleName, 'FORMS');
        }

      }, error: (error) => {
        this.isProcessing = false;
        console.error(error);
      }
    });
  }

  onSwitchUserLogSaved(switchedToUserId: any) {
    console.log("🔹 Switch User ID Received:", switchedToUserId);

    if (!switchedToUserId) {
      switchedToUserId = this.message.switchedUser;
      if (!switchedToUserId) return; // Stop if still null
    }

    this.isProcessing = true;

    // 1. Copy the current row data
    let updateData = { ...this.switchVerifierRowData };

    // 2. Clean up system fields
    delete updateData.createdOn;
    delete updateData.updatedOn;

    // 3. Find User Name from the dropdown list
    // We use '==' instead of '===' to handle string/number mismatch
    const selectedUserObj = this.dropdownForSwitchUsers.find((item: any) => item.valueExp == switchedToUserId);
    const selectedUserName = selectedUserObj ? selectedUserObj.displayExp : '';

    console.log("🔹 Selected Name:", selectedUserName);

    if (!this.switchVerifierSectionData.fieldsList) return;

    for (const field of this.switchVerifierSectionData.fieldsList) {
      if (!field.mappingColumn) continue;
      const key = this.getColumnName(field.mappingColumn);
      if (!key) continue;

      const defaultValue = field.fieldDefaultValue;
      const rowValue = this.switchVerifierRowData[key];

      if (field.fieldDatatype === "Date" || field.fieldDatatype === "Datetime") {
        const dateToConvert = defaultValue ?? rowValue;
        if (dateToConvert != null) {
          updateData[key] = new Date(dateToConvert);
        }
      }
      else if (field.fieldDatatype === "NUMBER") {
        updateData[key] = defaultValue ? Number.parseInt(defaultValue) : rowValue;
      }
      else {
        updateData[key] = defaultValue ?? rowValue;
      }
    }
    if (updateData.status === 'Pending Verification') {
      updateData.verifiedBy = switchedToUserId;
      if (selectedUserName) updateData.verifiedByUser = selectedUserName;
    } else if (updateData.status === 'Pending Withdrawal') {
      updateData.withdrawnBy = switchedToUserId;
      if (selectedUserName) updateData.withdrawnByUser = selectedUserName;
    }



    console.log("🔹 Final Payload sending to API:", updateData);

    // 6. Call update API
    this.appService.updateSectionData(updateData).subscribe({
      next: (Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: "User switched successfully",
              type: 'Success',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'Success'
          });

          // Refresh Grid
          this.callSectionData(this.switchVerifierSectionData);
          this.dropdownForSwitchUsers = [];
        } else {
          // Show Error
          this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result || "Failed to update record",
              type: 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'Error'
          });
        }
      },
      error: (error) => {
        this.isProcessing = false;
        console.error(error);
      }
    });
  }
  onUserActivity(): void {
    this.sessionTimeoutService.notifyActivity();
  }


}
